import Form from '@/app/components/UI/Form'
import Head from 'next/head'

export default function ContactSupportPage() {
  return (
    <>
      <Head>
        <title>Azul Agro - Contato de Assistência Técnica</title>
        <meta name="description" content="Entre em contato com a Azul Agro para tirar suas dúvidas sobre assistência técnica, solicitar informações ou receber suporte técnico especializado. Nossa equipe está pronta para ajudar você a otimizar suas operações agrícolas com nossas soluções de alta performance." />
      </Head>
      <main>
        <Form support />
      </main>
    </>
  )
}
